<template>
  <div class="container-pay" :style="cssVars()">
    <div class="custom-nav-block" :style="`paddingTop: ${topBarHeight}px`">
      <van-nav-bar class="van-bar" left-trangle @click-left="goBack" @click-right="goCustomer">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
          <!-- Checkout -->
          <span class="tit-left">Off_Line_{{ $t('lang.PayNext.k001') }}</span>
        </template>

        <template #right>
          <img class="icon-right" src="@/assets/packageAssets/views/P1_Boys/PayNext/default/customer.webp" alt="" />
        </template>
      </van-nav-bar>
    </div>

    <div class="main">
      <div class="pay">
        <div class="money-block">
          <img class="moneys" :src="getMatchImg('coin')" alt="" />
          <div class="amount">
            {{ myPlus(amount, presentAmount) }}
            <i v-if="selectedCoupon && selectedCoupon.amount != null">+{{ selectedCoupon.amount }}</i>
          </div>
        </div>
        <div class="pay-other">
          <template v-for="item in presentPropList">
            <div v-if="item.propType == 1" class="dis-item">
              <img :src="getMatchImg('chat-pass')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 2" class="dis-item">
              <img :src="getMatchImg('video-pass')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 4" class="dis-item">
              <img :src="getMatchImg('vip')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 6" class="dis-item">
              <img :src="getMatchImg('call-pass')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 9" class="dis-item">
              <img :src="getMatchImg('coupon')" />
              x{{ item.number }}
            </div>
            <div v-else-if="item.propType == 15" class="dis-item">
              <img :src="getMatchImg('super-chat-pass')" />
              x{{ item.number }}
            </div>
          </template>
        </div>
      </div>

      <!-- 优惠券入口 -->
      <div v-if="validCouponList.length" class="coupon-trigger">
        <div :class="{ 'show-item': true, 'color-border': showCoupons }" @click="handleClickCouponEnter">
          <template v-if="couponTriggerApplied">
            <div class="coupon-logo">
              <img :src="getMatchImg('coupon')" />
            </div>
            <div class="coupon-info">
              <p class="info-main">{{ $t('lang.PayNext.k016') }}</p>
            </div>
          </template>

          <template v-else-if="couponTriggerHasAvailable">
            <div class="coupon-logo">
              <img :src="getMatchImg('coupon-off')" />
            </div>
            <div class="coupon-info">
              <MyPLabel
                class="info-main"
                :str="$t('lang.PayNext.k017')"
                :numsOption="[{ value: maxCoupon ? `${maxCoupon.amount}` : '0' }]"
                :customClass="{ bean: 'pay-bean-icon' }"
              />
            </div>
          </template>

          <template v-else>
            <div class="coupon-logo">
              <img :src="getMatchImg('coupon-off')" />
            </div>
            <div class="coupon-info">
              <p class="info-main">{{ $t('lang.PayNext.k018') }}</p>
            </div>
          </template>

          <div class="coupon-arrow" :class="[showCoupons ? 'arrow-up' : '']"></div>
        </div>
      </div>

      <!-- Methods -->
      <div class="block-title">
        <div>{{ $t('lang.PayNext.k002') }}</div>
      </div>

      <div v-if="googlePrice" :class="['method-item', selectedIndex === 9999 ? 'method-on' : '']" @click.prevent="selectOriginPay">
        <div class="method-check" :class="[selectedIndex === 9999 ? 'checked' : '']"></div>
        <div :class="['method-con', hasGooglePayMarks() ? 'has-marks' : 'is-compact']">
          <div class="method-img">
            <img v-if="env.isAppIOS" src="@/assets/packageAssets/common/apple_pay.webp" alt="" />
            <img v-else src="@/assets/packageAssets/common/google.webp" alt="" />
          </div>
          <div class="method-name">
            <div v-if="env.isAppIOS" class="method-info">
              <span class="name">Apple Pay</span>
              <div v-if="lastUsedChannel == 'Apple Pay'" class="method-mark-container">
                <div class="method-mark last-used">{{ $t('lang.PayNext.k004') }}</div>
              </div>
            </div>

            <div v-else class="method-info">
              <span class="name">Google Pay</span>
              <div v-if="lastUsedChannel == 'Google Pay'" class="method-mark-container">
                <div class="method-mark last-used">{{ $t('lang.PayNext.k004') }}</div>
              </div>
            </div>

            <!-- 符号与金额不匹配问题-兼容 -->
            <div v-if="googleCurrencyPrice" class="rate">{{ googleCurrencyPrice }}</div>
            <div v-else class="rate">{{ googleCurrency }} {{ googlePrice }}</div>
          </div>
        </div>
      </div>

      <div v-for="(item, index) in payList" :key="item.name + item.timestamp" class="pay-method-cell">
        <div
          :class="['method-item', item.ifBestPrice === true ? 'best-type' : '', index === selectedIndex ? 'method-on' : '']"
          @click.prevent="selectThirdPay(item, index)"
        >
          <div class="method-check" :class="[index === selectedIndex ? 'checked' : '']"></div>
          <div :class="['method-con', hasMethodMarks(item) ? 'has-marks' : 'is-compact']">
            <div class="method-img"><img :src="item.icon | imgPath" alt="" /></div>
            <div class="method-name" v-if="item.icon">
              <div class="method-info">
                <div class="name">{{ item.name }}</div>
                <div v-if="hasMethodMarks(item)" class="method-mark-container">
                  <div v-if="item.label" class="method-mark discount">
                    {{ item.label }}
                  </div>
                  <div v-if="showLastUsedMark(item)" class="method-mark last-used">{{ $t('lang.PayNext.k004') }}</div>
                  <div v-if="item.tipType === 3" class="method-mark discount-first-use">{{ $t('lang.PayNext.k011') }}</div>
                  <MyPLabel
                    v-if="showMostPopularMark(item)"
                    class="method-mark most-favorable"
                    :str="$t('lang.PayNext.k003')"
                    :customClass="{ coin: 'pay-coin-icon' }"
                  />
                </div>
              </div>
              <!-- 不同国家地区金额展示习惯localizedPrice -->
              <div class="rate" :data-localized="item.localizedPrice || 'unknown'">{{ applyPrice(item) }}</div>
            </div>
          </div>
        </div>
        <div v-if="item.tipType === 1 || item.tipType === 2" :class="'method-tip-section'" @click.stop="toggleTip(index)">
          <div class="tip-header">
            <span class="tip-title">👉🏻 {{ $t('lang.PayNext.k005') }}</span>
            <div class="tip-arrow" :class="[tipExpandMap[index] ? 'arrow-up' : '']"></div>
          </div>
          <template v-if="tipExpandMap[index]">
            <div v-if="item.tipType === 1" class="tip-body">
              <div>{{ $t('lang.PayNext.k006') }}</div>
              <div>{{ $t('lang.PayNext.k007') }}</div>
              <div>{{ $t('lang.PayNext.k008') }}</div>
            </div>
            <div v-else-if="item.tipType === 2" class="tip-body">
              <div>{{ $t('lang.PayNext.k009') }}</div>
              <div>{{ $t('lang.PayNext.k010') }}</div>
            </div>
          </template>
        </div>
      </div>

      <!-- 底部栏占位用 -->
      <div style="width: 100%; height: 300px"></div>

      <div class="submit-btn-block">
        <!-- prettier-ignore -->
        <div v-if="showPriceBlock" class="price-block">
          <div>{{ $t('lang.PayNext.k019') }}</div>
          <div v-if="selectedItem">
            <MyPLabel v-if="selectedItem.discount" class="discount-tag" :str="$t('lang.PayNext.k020')" :numsOption="[{ value: selectedPayLabel }]" />
            <div class="price-value" :data-localized="selectedItem.localizedPrice || 'unknown'">{{ applyPrice(selectedItem) }}</div>
          </div>
        </div>
        <div v-else style="height: 10px"></div>
        <div class="submit-btn" @click="handleClickPay">
          <span>{{ $t('lang.PayNext.k021') }}</span>
          <van-loading v-if="loadingShow" type="spinner" class="pay-loading" size="20px" />
        </div>
        <div :style="{ height: `${bottomBarHeight || 30}px` }"></div>
      </div>
    </div>

    <!-- 优惠券抽屉 -->
    <van-popup
      v-model="showCoupons"
      position="bottom"
      round
      :lock-scroll="true"
      get-container=".container-pay"
      :style="cssVars()"
      class="coupon-drawer-popup"
    >
      <div class="coupon-drawer">
        <div class="coupon-drawer-header">
          <span class="coupon-drawer-title">{{ $t('lang.PayNext.k012') }}</span>
        </div>
        <div class="coupon-scroll" :class="{ 'is-single-coupon': isSingleCouponDrawer }">
          <div v-for="section in couponDrawerSections" :key="section.key">
            <div v-if="section.list.length" class="coupon-section">
              <div class="coupon-section-title">
                <MyPLabel :str="$t(section.titleKey)" :numsOption="[{ value: section.list.length }]" />
              </div>
              <div class="coupon-section-list">
                <div
                  v-for="item in section.list"
                  :key="item.couponRecordId"
                  :class="{
                    'coupon-item': true,
                    'coupon-item-disabled': !section.selectable,
                    'coupon-item-selected': section.selectable && selectedCoupon && item.couponRecordId === selectedCoupon.couponRecordId,
                  }"
                  @click="section.selectable && handleSelectCoupon(item)"
                >
                  <div class="coupon-card-bg"></div>
                  <div class="coupon-card-border"></div>
                  <div class="coupon-card-content">
                    <div class="coupon-card-main">
                      <div class="coupon-card-text">
                        <div class="coupon-card-name">{{ $t('lang.PayNext.k022') }}</div>
                        <MyPLabel class="coupon-card-desc" :str="item.descV2" :customClass="{ coin: 'pay-coin-icon' }" />
                      </div>
                      <div class="coupon-card-bonus">
                        <div class="coupon-card-amount">+{{ item.amount }}</div>
                        <div class="coupon-card-unit">{{ $t('lang.BaseModule.k013') }}</div>
                      </div>
                    </div>
                    <div class="coupon-card-divider"></div>
                    <div class="coupon-card-footer">
                      <MyPLabel
                        class="coupon-card-date"
                        :str="$t('lang.PayNext.k015')"
                        :numsOption="[{ value: formatCouponExpiredTime(item.expiredTime) }]"
                      />
                    </div>
                  </div>
                  <div
                    v-if="section.selectable"
                    class="coupon-check"
                    :class="[selectedCoupon && item.couponRecordId === selectedCoupon.couponRecordId ? 'checked' : 'not-checked']"
                  ></div>
                  <div v-else class="coupon-check not-checked"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div :style="{ height: `${bottomBarHeight || 0}px` }"></div>
      </div>
    </van-popup>

    <!-- 支付结果弹窗 -->
    <c-confirm :showDiaC="showResultDia" :oneShow="true" :title="payResultText" />
  </div>
</template>

<script>
// 多包样式
import { pageCssVars } from '@/views/P1_Boys/PayNext/z-style-cfg.js'

import { apiFetchPayList, apiFetchShopOrder } from '@/api/imee'
import { mixin } from './base.mixin.js'

import _debounce from 'lodash/debounce'

import CConfirm from '@/components/CConfirm'

function strToNum(str) {
  let result = null
  if (str) {
    // prettier-ignore
    try {
      result = str * 1
    }
    catch (err) {
      result = null
    }
  }
  return result
}

function normalizePayList(list) {
  const baseTime = Date.now()
  return (list || []).map((item, index) => ({
    ...item,
    timestamp: item.timestamp ?? baseTime + index,
  }))
}

export default {
  components: { CConfirm },
  mixins: [pageCssVars, mixin],
  data() {
    const query = this.$route.query
    return {
      // 产品信息
      gid: query.gid || null,
      productId: query.productId || null,

      // 方式-google/apple
      googlePrice: query.price || null,
      googleCurrency: query.currency || null,
      googleCurrencyPrice: query.currencyPrice || null,

      // 优惠信息
      amount: 0,
      presentAmount: 0,
      presentPropList: [],

      // 方式-三方
      payList: [],
      locationCode: '',

      // 选中相关
      lastUsedChannel: '',
      selectedIndex: -1,
      selectedItem: null,

      // 控制参数-提示loading
      loadingShow: false,

      // 支付方式统计
      selectChannelIndex: -1,

      // 提示语展开状态
      tipExpandMap: {},

      // 收银台曝光埋点
      checkoutPageEnterTracked: false,
    }
  },
  computed: {
    /** 支付按钮展示金币：基础 amount + presentAmount + 已选优惠券 amount */
    submitBtnCoinTotal() {
      const couponAmount = this.selectedCoupon && this.selectedCoupon.amount != null ? this.selectedCoupon.amount : 0
      return this.myPlus(this.myPlus(this.amount, this.presentAmount), couponAmount)
    },
    // 作用：所选支付方式存在 label 时展示底部 price-block
    showPriceBlock() {
      return !!this.selectedItem
    },
    // 作用：获取所选支付方式的折扣标签文案
    selectedPayLabel() {
      if (!this.selectedItem || !this.selectedItem.discount) return ''
      return `${this.selectedItem.discount}%`
    },
    // 仅一张优惠券时，滚动区预留第二张券高度
    isSingleCouponDrawer() {
      return (this.validCouponList || []).length === 1
    },
  },
  methods: {
    // 不同国家地区金额展示：优先 localizedPrice / currencyPrice
    applyPrice(item) {
      if (!item) return ''
      return item.localizedPrice || item.currencyPrice || `${item.currency} ${this.handleDiv100(item.price)}`
    },

    // 支付方式提示-展开/收起
    toggleTip(index) {
      this.$set(this.tipExpandMap, index, !this.tipExpandMap[index])
    },

    // 谷歌/apple支付是否有标签
    hasGooglePayMarks() {
      if (this.env.isAppIOS) {
        return this.lastUsedChannel === 'Apple Pay'
      }
      //
      else {
        return this.lastUsedChannel === 'Google Pay'
      }
    },

    // 三方支付是否有标签
    hasMethodMarks(item) {
      if (!item) return false
      if (item.tipType === 3) return true
      if (this.showMostPopularMark(item) || this.showLastUsedMark(item)) return true
      return !!(item.label && String(item.label).trim())
    },
    showMostPopularMark(item) {
      return !!(item && item.ifBestPrice === true && !item.lastUsed)
    },
    showLastUsedMark(item) {
      return !!(item && item.lastUsed)
    },

    notifyCheckoutPageReady() {
      if (!this.thirdPayListReady || this.checkoutPageEnterTracked) {
        return
      }
      this.trackCheckoutPageEnter()
    },

    resolveCheckoutGoodsPropType() {
      const types = ['coin']
      ;(this.presentPropList || []).forEach((item) => {
        const propName = this.propsMap[item.propType]
        if (propName && propName !== '?' && !types.includes(propName)) {
          types.push(propName)
        }
      })
      return types.join(',')
    },

    resolveCheckoutCurrencyCode() {
      return this.googleCurrency || (this.payList[0] && this.payList[0].currency) || this.$route.query.currency || ''
    },

    resolveCheckoutCouponUsable() {
      if (this.scene === 'activity') {
        return false
      }
      return (this.validCouponList || []).some((item) => item.canUse === true)
    },

    trackCheckoutPageEnter() {
      if (this.checkoutPageEnterTracked) {
        return
      }
      this.checkoutPageEnterTracked = true

      const appInfo = this.$client.getAppInfo() || {}
      this.$client.addEvent('checkout_page_enter', {
        app_version: appInfo.version || '',
        app_language: this.$client.getAppInfoLang() || '',
        app_device_id: appInfo.deviceId || '',
        app_package_name: appInfo.appPackageName || '',
        channel: appInfo.channel || '',
        account_id: String(this.getUid() || ''),
        source_page: this.scene || '',
        currency_code: this.resolveCheckoutCurrencyCode(),
        goods_prop_type: this.resolveCheckoutGoodsPropType(),
        is_coupon_usable: this.resolveCheckoutCouponUsable(),
        country_code: this.locationCode || '',
      })
    },

    thirdPay: _debounce(
      function (item) {
        let payChannelTotal = null
        if (this.payList && this.payList.length) {
          payChannelTotal = this.payList.length
        }
        let payChannelIndex = null
        if (this.selectChannelIndex != -1 && payChannelTotal !== null && payChannelTotal !== 0) {
          payChannelIndex = payChannelTotal - 1 - this.selectChannelIndex
        }
        if (this.googlePrice && this.googleCurrency && payChannelTotal !== null && payChannelIndex !== null) {
          payChannelTotal = payChannelTotal + 1
          payChannelIndex = payChannelIndex + 1
        }

        const data = {
          tierId: this.$route.query.tierId || null,
          shopType: this.$route.query.shopType || null,
          gid: this.gid,
          payType: item.payType,
          scene: this.scene,
          thirdParam: this.thirdParam,
          payChannel: item.name,
          payChannelIndex: payChannelIndex,
          payChannelTotal: payChannelTotal,
        }
        if (this.$route.query.videoChatScene) {
          data.videoChatScene = this.$route.query.videoChatScene
        }
        if (this.$route.query.activityType) {
          data.activityType = this.$route.query.activityType
        }
        if (this.selectedCoupon && this.scene != 'activity') {
          data.couponRecordId = this.selectedCoupon.couponRecordId
        }
        if (this.scene == 'activity') {
          data.shopType = 7
        }
        this.$client.addEvent('top_up', {
          Action: 'Click',
          APosition: 'payButton',
          productID: this.productId,
          goodtype: 'coin',
          from: 'cash',
          paymethod: item.name,
        })

        if (this.loadingShow === true) {
          return
        }

        this.loadingShow = true

        apiFetchShopOrder(data)
          .then((res) => {
            // 下单后刷新优惠券
            this.initCoupon()

            if (res.status !== 200 || !res.data) {
              return
            }

            const openInExternalBrowser = res.data.credential?.openInExternalBrowser || false
            const wapUrl = res.data.credential?.wapUrl || ''
            // 外部浏览器打开
            if (openInExternalBrowser) {
              this.appAction('open_web_outside', `?url=${wapUrl}`)

              // 调用三方支付后，无法检测支付状态，直接关闭web
              if (['10', '18', '19', '27'].includes(this.$route.query.activityType)) {
                this.closeWeb()
              }
            }
            // webview打开
            else {
              if (wapUrl) {
                this.$router.push({
                  path: '/pay-code',
                  query: { url: wapUrl },
                })
              }
            }
          })
          .finally(() => {
            this.loadingShow = false
          })
      },
      2000,
      {
        leading: true,
        trailing: false,
      }
    ),

    originPay() {
      // 从 h5 活动页进入，客户端不知道商品信息，不知道优惠券信息
      if (this.$route.query.useWebPay == '1') {
        const params = {
          gid: this.gid,
          productId: this.$route.query.productId || '',
          activityType: this.$route.query.activityType * 1,
          scene: this.$route.query.scene || '',
          tierId: strToNum(this.$route.query.tierId),
          shopType: this.$route.query.shopType || null,
        }

        // echo
        if (this.packageName === 'echo') {
          nativePaymentFromWeb.postMessage(JSON.stringify(params))
        }
        // 其他包
        else {
          payGoogleFromWeb.postMessage(JSON.stringify(params))
        }

        // 客户端原生支付成功后，web可以监听window.refresh
        // 回到上级活动页面，后续逻辑由活动页面处理
        if (['10', '18', '19', '27'].includes(this.$route.query.activityType)) {
          this.goPrevious()
        }
      }
      // 从客户端商品列表进入，客户端知道商品信息，不知道优惠券信息
      else {
        const params = {
          tierId: strToNum(this.$route.query.tierId),
          shopType: this.$route.query.shopType || null,
          extendPay: this.$route.query.extendPay || null,
        }

        if (this.selectedCoupon) {
          params.couponRecordId = this.selectedCoupon.couponRecordId
        }

        // echo
        if (this.packageName === 'echo') {
          nativePayment.postMessage(JSON.stringify(params))
        }
        // 其他包
        else {
          payGoogle.postMessage(JSON.stringify(params))
        }
      }
    },

    // 点击支付按钮-执行支付
    handleClickPay: _debounce(
      function () {
        if (this.selectedIndex > -1) {
          const tempKeys = Object.keys(this.selectedItem)
          // thirdpay
          if (tempKeys && tempKeys.length && this.selectedIndex !== 9999) {
            this.thirdPay(this.selectedItem)
          }
          // googlpay/applepay
          else {
            this.originPay()
          }
        }
      },
      500,
      {
        leading: true,
        trailing: false,
      }
    ),

    // 三方支付-点击选中
    selectThirdPay(item, index) {
      this.selectedItem = item
      this.selectedIndex = index
    },

    // 谷歌/apple支付-点击选中
    selectOriginPay() {
      if (this.googlePrice) {
        this.selectThirdPay(
          {
            currency: this.googleCurrency,
            price: this.myTimes(this.googlePrice, 100),
            currencyPrice: this.googleCurrencyPrice,
          },
          9999
        )
      }
    },

    // 获取三方支付列表
    fetchPayList() {
      if (!this.gid) {
        return
      }

      const resolvePayList = (data) => {
        this.productId = data.productId
        this.amount = data.amount || 0
        this.presentAmount = data.presentAmount || 0
        this.presentPropList = data.presentPropListV2 || []
        this.lastUsedChannel = data.lastUsedChannel || 'unknown'
        this.defaultChannel = data.defaultChannel || 'unknown'
        this.locationCode = data.locationCode || ''

        this.payList = normalizePayList(data.payChannelList)

        // 排序三方支付方式-最优、上次使用
        this.resolveBestAndLastUsed()

        // 默认选中相关-三方支付信息获取完成
        this.thirdPayListReady = true

        this.initCoupon()
      }

      apiFetchPayList({
        gid: this.gid,
        activityType: this.$route.query.activityType,
        tierId: this.$route.query.tierId || null,
        shopType: this.getShopType(),
      }).then((res) => {
        if (res.status === 200 && res.data && res.data.payChannelList) {
          resolvePayList(res.data)
        }
      })
    },

    // 获取谷歌/apple支付-客户端回调
    queryGoogleProductListCallback(res) {
      if (res) {
        try {
          const googlePayList = JSON.parse(res)
          const targetItem = googlePayList.find((item) => {
            return this.$route.query.productId == item.productId
          })
          if (targetItem) {
            this.googlePrice = targetItem.price
            this.googleCurrency = targetItem.currencyCode
            this.googleCurrencyPrice = targetItem.currencyPrice
          }
        } catch (err) {
          console.log('try catch err:', err)
        }
      }

      // 默认选中相关-原生支付信息获取完成
      this.originPayInfoReady = true
    },

    // 原生支付完成后，客户端调用window.refresh
    refresh() {
      // 从活动页面进入
      if (this.$route.query.useWebPay == '1') {
        this.init()
      }
      // 从客户端进入
      else {
        this.closeWeb()
      }
    },

    reset() {
      // 回退刷新重置
      this.defaultChannel = ''
      this.originPayInfoReady = true
      this.thirdPayListReady = false
    },

    init() {
      this.reset()
      this.fetchPayList()
    },
  },
  created() {
    this.init()

    // 客户端回调刷新
    window.refresh = this.refresh

    // 获取客户端原生支付
    if (this.packageName === 'echo') {
      window.queryProductListCallback = this.queryGoogleProductListCallback
    }
    //
    else {
      window.queryGoogleProductListCallback = this.queryGoogleProductListCallback
    }

    if (this.$route.query.productId) {
      this.$client.googleProductList([this.$route.query.productId], this.packageName)
    }

    // 默认选中相关-原生支付信息获取完成
    if ((!this.$route.query.productId && this.$route.query.price) || !this.$route.query.price) {
      this.originPayInfoReady = true
    }
  },
}
</script>
<style lang="scss" scoped>
.container-pay {
  width: 100%;
  min-height: 100vh;
  position: relative;
  background: var(--bg-color01);

  .custom-nav-block {
    background-color: #ffffff;

    .tit-left {
      line-height: var(--lh-title-20);
      color: var(--word-color01);
    }

    .icon-right {
      box-sizing: content-box;
      width: 25px;
      height: 25px;
    }
  }

  .main {
    padding: 24px 16px;

    .pay {
      width: 100%;

      .money-block {
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: var(--string-font);

        .moneys {
          width: 30px;
          height: 30px;
        }

        .amount {
          font-family: var(--number-font, 'Inter-Regular');
          font-size: var(--fs-24);
          font-weight: var(--fw-700);
          line-height: var(--lh-headline-32);
          color: var(--word-color02);

          i {
            font-weight: var(--fw-400);
            color: var(--word-color03);
          }
        }
      }

      .pay-other {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;

        .dis-item {
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 4px;
          font-family: var(--number-font);
          font-size: var(--fs-16);
          font-weight: var(--fw-400);
          line-height: var(--lh-label-18);
          color: var(--word-color04);

          img {
            width: 24px;
            height: 24px;
            margin-right: 4px;
          }
        }
      }
    }

    .coupon-trigger {
      margin: 20px auto 0;
      background: var(--bg-color02);
      border-radius: 8px;

      .show-item {
        display: flex;
        align-items: center;
        padding: 12px;
        border-radius: 8px;
        background: var(--bg-color03);

        .coupon-logo {
          display: flex;
          align-items: center;
          justify-content: center;

          > img {
            width: 24px;
            height: 24px;
          }
        }

        .coupon-info {
          flex: 1;

          .info-main {
            padding-left: 18px;
            font-family: var(--string-font);
            font-size: var(--fs-12);
            font-weight: var(--fw-400);
            line-height: var(--lh-body-18);
            color: var(--word-color05);
          }
        }

        .coupon-arrow {
          width: 20px;
          height: 20px;
          background: url('~@/assets/packageAssets/views/P1_Boys/PayNext/default/arrow.webp') top left / 100% 100% no-repeat;
          transform: rotateZ(0deg);

          &.arrow-up {
            transform: rotateZ(180deg);
          }
        }
      }
    }

    .block-title {
      display: flex;
      align-items: flex-start;
      margin-top: 20px;

      div {
        width: 100%;
        font-family: var(--string-font);
        font-size: var(--fs-16);
        font-weight: var(--fw-600);
        line-height: var(--lh-title-20);
        color: var(--word-color24);
      }
    }

    .method-item {
      position: relative;
      width: 100%;
      margin-top: 12px;
      border-radius: 10px;
      overflow: hidden;
      background: #ffffff;
      box-shadow: 0 0 1.5px 0 transparent inset;

      &.method-on {
        box-shadow: 0 0 0 1.5px var(--bg-color04) inset;
      }

      .method-check {
        position: absolute;
        top: 0;
        right: 0;
        width: 28px;
        height: 28px;

        &.checked {
          background: var(--icon-img01) top left / 100% 100% no-repeat;
        }
      }

      .method-con {
        display: flex;
        width: 100%;
        padding: 12px;

        &.is-compact {
          align-items: center;

          .method-name {
            align-items: center;

            .rate {
              height: auto;
            }
          }
        }

        &.has-marks {
          align-items: flex-start;

          .method-name {
            align-items: flex-start;

            .rate {
              height: 44px;
            }
          }
        }

        .method-img {
          display: flex;
          justify-content: center;
          width: 44px;
          height: 44px;
          margin-right: 12px;
          border-radius: 5px;
          background: var(--bg-color05);

          > img {
            width: 44px;
            object-fit: contain;
          }
        }

        .method-name {
          display: flex;
          flex: 1;
          justify-content: space-between;
          width: 100%;

          .method-info {
            display: flex;
            flex: 1;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            min-width: 0;

            .name {
              font-family: 'Roboto-Regular';
              font-size: 16px;
              font-weight: var(--fw-500);
              line-height: 20px;
              color: var(--word-color06);
            }

            .method-mark-container {
              display: flex;
              flex-wrap: wrap;
              align-items: center;
              margin-left: -4px;

              .method-mark {
                flex-shrink: 0;
                margin-top: 4px;
                margin-left: 4px;
                padding: 3px 6px;
                border-radius: 2px;
                white-space: nowrap;
                font-family: var(--string-font);
                font-size: var(--fs-12);
                font-weight: var(--fw-500);
                line-height: var(--lh-label-14);

                &.discount {
                  background: rgba(255, 66, 101, 0.05);
                  color: #ff4265;
                }

                &.discount-first-use {
                  background: rgba(255, 91, 1, 0.05);
                  color: #ff8542;
                }

                &.last-used {
                  background: rgba(255, 187, 40, 0.1);
                  color: #c36f00;
                }

                &.most-favorable {
                  background: var(--most-favorable-bg);
                  color: var(--most-favorable-color);
                }
              }
            }
          }

          .rate {
            display: flex;
            flex-shrink: 0;
            align-items: center;
            font-family: var(--number-font);
            font-size: var(--fs-16);
            font-weight: var(--fw-500);
            color: var(--word-color07);
            white-space: nowrap;
          }
        }
      }
    }

    .pay-method-cell {
      position: relative;
      isolation: isolate;

      > .method-item {
        position: relative;
        z-index: 2;
      }

      .method-tip-section {
        position: relative;
        z-index: 1;
        margin-top: -10px;
        padding-top: 10px;
        border-radius: 10px;
        background: var(--bg-color06);
        overflow: hidden;
        cursor: pointer;

        .tip-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 8px 10px;

          .tip-title {
            flex: 1;
            color: var(--word-color08);
            font-family: var(--number-font, 'InterTight-Regular');
            font-size: 12px;
            font-weight: 500;
            line-height: 18px;
          }

          .tip-arrow {
            flex-shrink: 0;
            width: 12px;
            height: 12px;
            background: url('~@/assets/packageAssets/views/P1_Boys/PayNext/default/arrow.webp') top left / 100% 100% no-repeat;
            transform: rotateZ(0deg);
            transition: transform 0.2s ease;

            &.arrow-up {
              transform: rotateZ(180deg);
            }
          }
        }

        .tip-body {
          padding: 0 12px 10px 30px;
          color: var(--word-color09);
          font-family: var(--number-font, 'InterTight-Regular');
          font-size: 12px;
          font-weight: 400;
          line-height: 18px;

          > div {
            margin-bottom: 6px;

            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
    }

    .submit-btn-block {
      position: fixed;
      left: 0;
      bottom: 0;
      z-index: 999;
      width: 100%;
      padding-top: 12px;
      background: #ffffff;
      box-shadow: 0 -2px 8px 0 rgba(0, 0, 0, 0.1);

      .price-block {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 16px 12px;

        > div {
          &:first-child {
            font-family: var(--string-font);
            font-size: var(--fs-16);
            font-weight: var(--fw-400);
            line-height: var(--lh-title-20);
            color: var(--word-color10);
          }

          &:last-child {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: flex-end;
            max-width: 220px;

            .discount-tag {
              margin: 8px 4px 4px;
              white-space: nowrap;
              color: var(--word-color25);
              font-family: var(--number-font);
              font-size: var(--fs-14);
              font-weight: var(--fw-500);
              line-height: var(--lh-label-18);
            }

            .price-value {
              max-width: 220px;
              font-family: var(--number-font);
              font-size: 22px;
              font-weight: var(--fw-600);
              line-height: var(--lh-headline-32);
              color: var(--word-color11);
              word-break: break-all;
            }
          }
        }
      }

      .submit-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: auto 16px;
        padding: 10px;
        border-radius: var(--page-radius01);
        background: var(--bg-color07);
        font-family: var(--string-font);
        font-size: 18px;
        font-weight: var(--fw-500);
        line-height: var(--lh-headline-28);
        font-style: normal;
        color: var(--word-color12);
        text-align: center;

        .pay-loading {
          color: var(--word-color13);
        }

        img {
          width: 20px;
          margin: 0 3px;
        }
      }
    }
  }
}

::v-deep .coupon-drawer-popup {
  background: transparent;
  border-radius: 20px 20px 0 0;
  overflow: hidden;

  .coupon-drawer {
    display: flex;
    flex-direction: column;
    max-height: 60vh;
    background: var(--coupon-drawer-bg);

    .coupon-drawer-header {
      flex-shrink: 0;
      padding: 14px 16px;
      text-align: center;

      .coupon-drawer-title {
        font-family: var(--string-font);
        font-size: var(--fs-20);
        font-weight: var(--fw-500);
        line-height: var(--lh-title-28);
        color: var(--word-color26);
      }
    }

    .coupon-scroll {
      flex: 1;
      max-height: calc(70vh - 56px);
      overflow-y: auto;

      &.is-single-coupon {
        // section-title(28) + list-padding(16) + 2*coupon-item(95) + item-gap(10)
        min-height: calc(28px + 16px + 95px * 2 + 10px);
      }

      .coupon-section {
        .coupon-section-title {
          padding: 4px 16px;

          .custom-p-label {
            margin: 0;
            font-family: var(--string-font);
            font-size: var(--fs-14);
            font-weight: var(--fw-400);
            line-height: var(--lh-title-20);
            color: var(--word-color27);
          }
        }

        .coupon-section-list {
          padding: 8px 16px;

          .coupon-item {
            position: relative;
            padding: 8px 16px 8px 12px;
            border-radius: 8px;
            overflow: hidden;

            &:not(:first-child) {
              margin-top: 10px;
            }

            .coupon-card-bg {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              background: var(--coupon-card-bg);
              pointer-events: none;

              &::before,
              &::after {
                content: '';
                position: absolute;
                top: calc(50% + 2px);
                width: 12px;
                height: 12px;
                border-radius: 50%;
                background: var(--coupon-drawer-bg);
              }

              &::before {
                left: 0;
                transform: translate(-50%, -50%);
              }

              &::after {
                right: 0;
                transform: translate(50%, -50%);
              }
            }

            .coupon-card-border {
              display: none;
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              height: 100%;
              background: var(--coupon-on-img) top left / 100% 100% no-repeat;
              pointer-events: none;
              z-index: 1;
            }

            &.coupon-item-selected {
              .coupon-card-border {
                display: block;
              }
            }

            .coupon-card-content {
              position: relative;
              z-index: 2;
            }

            .coupon-card-main {
              position: relative;
              z-index: 2;
              display: flex;
              align-items: flex-start;
            }

            .coupon-card-text {
              flex: 1;
              min-width: 0;
              padding-top: 3px;
            }

            .coupon-card-name {
              font-family: var(--string-font);
              font-size: var(--fs-16);
              font-weight: var(--fw-500);
              line-height: 24px;
              color: var(--coupon-color-name);
            }

            .coupon-card-desc {
              margin-top: 5px;

              .custom-p-label {
                margin: 0;
                font-family: var(--string-font);
                font-size: var(--fs-12);
                font-weight: var(--fw-400);
                line-height: 16px;
                color: var(--coupon-color-desc);
              }
            }

            .coupon-card-bonus {
              flex-shrink: 0;
              width: 62px;
            }

            .coupon-card-amount {
              display: flex;
              align-items: center;
              justify-content: flex-end;
              font-family: var(--number-font, 'Inter-Regular');
              font-size: var(--fs-24);
              font-weight: var(--fw-700);
              line-height: 32px;
              color: var(--coupon-color-amount);
            }

            .coupon-card-unit {
              display: flex;
              align-items: center;
              justify-content: flex-end;
              margin-top: 2px;
              padding: 0 2px;
              font-family: var(--string-font);
              font-size: var(--fs-14);
              font-weight: var(--fw-400);
              line-height: 18px;
              color: var(--coupon-color-unit);
            }

            .coupon-card-divider {
              position: relative;
              z-index: 2;
              height: 1px;
              margin: 4px 0;
              background: linear-gradient(90deg, rgba(51, 51, 51, 0) 0%, rgba(51, 51, 51, 0.08) 50%, rgba(51, 51, 51, 0) 100%);
            }

            .coupon-card-footer {
              position: relative;
              z-index: 2;
              padding-top: 4px;
              padding-right: 36px;

              .coupon-card-date {
                .custom-p-label {
                  margin: 0;
                  font-family: var(--string-font);
                  font-size: var(--fs-10);
                  font-weight: var(--fw-400);
                  line-height: 14px;
                  color: var(--coupon-color-date);
                }
              }
            }

            .coupon-check {
              position: absolute;
              right: 16px;
              bottom: 6px;
              z-index: 3;
              width: 20px;
              height: 20px;
              flex-shrink: 0;

              &.checked {
                background: var(--icon-img03) top left / 100% 100% no-repeat;
              }

              &.not-checked {
                background: var(--icon-img04) top left / 100% 100% no-repeat;
              }
            }

            &.coupon-item-disabled {
              pointer-events: none;

              .coupon-card-content,
              .coupon-check {
                filter: grayscale(1);
                opacity: 0.72;
              }

              ::v-deep .pay-coin-icon,
              ::v-deep .unique-coin-icon {
                filter: grayscale(1);
              }

              &::after {
                content: '';
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                height: 100%;
                border-radius: 8px;
                background: rgba(255, 255, 255, 0.42);
                pointer-events: none;
                z-index: 4;
              }
            }
          }
        }
      }
    }
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .container-pay {
    .main {
      .method-item {
        .method-check {
          right: unset;
          left: 0;

          &.checked {
            background: var(--icon-img02) top left / 100% 100% no-repeat;
          }
        }

        .method-con {
          .method-img {
            margin-right: unset;
            margin-left: 12px;
          }
        }
      }

      .coupon-trigger {
        .show-item {
          .coupon-info {
            .info-main {
              padding-left: 0;
              padding-right: 18px;
            }
          }
        }
      }

      .pay {
        .pay-other {
          .dis-item {
            img {
              margin-right: unset;
              margin-left: 4px;
            }
          }
        }
      }
    }

    ::v-deep .coupon-drawer-popup {
      .coupon-drawer {
        .coupon-scroll {
          .coupon-section {
            .coupon-section-list {
              .coupon-item {
                padding: 8px 12px 8px 16px;

                .coupon-card-footer {
                  padding-right: unset;
                  padding-left: 36px;
                }

                .coupon-check {
                  right: unset;
                  left: 16px;
                }
              }
            }
          }
        }
      }
    }
  }
}

::v-deep .pay-coin-icon,
::v-deep .pay-bean-icon {
  width: 16px;
  height: 16px;
  vertical-align: middle;
}
</style>
